import 'css-chunksrc/client/common/resourceAllocationMenu/resources/resource/styles.scss';export default {
  "resource": "_resource_vefl0_1",
  "icon": "_icon_vefl0_11",
  "col": "_col_vefl0_18",
  "name": "_name_vefl0_22",
  "profession": "_profession_vefl0_29"
};